import React, { Component } from 'react';
import { ToastContainer,toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { css } from 'react-emotion';
// First way to import
import { ClipLoader } from 'react-spinners';
import APIService from '../Services/APIService/apiService';
import { Button, Badge } from 'reactstrap';
import {  Redirect } from 'react-router-dom';


const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class Adrenalin extends Component{

    constructor(props){
        super(props);
        this.state = {
            APIName: "adrenalin",
            APIUser: "",
            APIPass: "",
            EasyApiUser: "",
            EasyApiPassword: "",
            ApiAddress: "",
            ExportTimeOutMinutes: "",
            CompanyId: "",
            Key: "",
            FtpPath: "",
            FtpFolderBase: "",
            FtpUser: "",
            FtpPsw: "",
            EmailsAlertTo: "",
            EmailSubjectError:"",
            loadingAdrenalin: false,
            type: 'password',
            APIPasswordType: 'password',
            FTPPasswordType: 'password',
            isAutenticated: true
        };
        this.handleApiUser = this.handleApiUser.bind(this);
        this.handleApiPass = this.handleApiPass.bind(this);
        this.handleEasyApiUser = this.handleEasyApiUser.bind(this);
        this.handleEasyApiPassword = this.handleEasyApiPassword.bind(this);
        this.handleApiAddress= this.handleApiAddress.bind(this);
        this.handleExportTimeOutMinutes = this.handleExportTimeOutMinutes.bind(this);
        this.handleCompanyId = this.handleCompanyId.bind(this);
        this.handleKey = this.handleKey.bind(this);
        this.handleFtpPath = this.handleFtpPath.bind(this);
        this.handleFtpFolderBase = this.handleFtpFolderBase.bind(this);
        this.handleFtpUser = this.handleFtpUser.bind(this);
        this.handleFtpPsw = this.handleFtpPsw.bind(this);
        this.handleEmailsAlertTo = this.handleEmailsAlertTo.bind(this);
        this.handleEmailSubjectError = this.handleEmailSubjectError.bind(this);
        this.showHide = this.showHide.bind(this);
        this.showHideAPIPasswordType = this.showHideAPIPasswordType.bind(this);
        this.showHideFTPPasswordType = this.showHideFTPPasswordType.bind(this);
    }  

    showHide(e){
        e.preventDefault();
        e.stopPropagation();
        this.setState({
          type: this.state.type === 'input' ? 'password' : 'input'
        })  
    }
    showHideAPIPasswordType(e){
        e.preventDefault();
        e.stopPropagation();
        this.setState({
          APIPasswordType: this.state.APIPasswordType === 'input' ? 'password' : 'input'
        })  
    }
    showHideFTPPasswordType(e){
        e.preventDefault();
        e.stopPropagation();
        this.setState({
           FTPPasswordType: this.state.FTPPasswordType === 'input' ? 'password' : 'input'
        })  
    }
    componentDidMount(){
      
        var AdrenalinList = this.props.DataAdrenalin;

        var Adrenalin = AdrenalinList.find(x=> x.ALIAS === this.state.APIName); 
        var AdrenalinValue = JSON.parse(Adrenalin.VALUE);
        var UserName = AdrenalinValue.UserName === null || AdrenalinValue.UserName === undefined   ? "" :  AdrenalinValue.UserName;
        var Pass = AdrenalinValue.Password === null || AdrenalinValue.Password === undefined   ? "" :  AdrenalinValue.Password;
        var EasyApiUser = AdrenalinValue.EasyApiUser === null || AdrenalinValue.EasyApiUser === undefined   ? "" :  AdrenalinValue.EasyApiUser;
        var EasyApiPassword = AdrenalinValue.EasyApiPassword === null || AdrenalinValue.EasyApiPassword === undefined   ? "" :  AdrenalinValue.EasyApiPassword;
        var ApiAddress = AdrenalinValue.ApiAddress === null || AdrenalinValue.ApiAddress === undefined   ? "" :  AdrenalinValue.ApiAddress;
        var ExportTimeOutMinutes = AdrenalinValue.ExportTimeOutMinutes === null || AdrenalinValue.ExportTimeOutMinutes === undefined   ? "" :  AdrenalinValue.ExportTimeOutMinutes;
        var CompanyId = AdrenalinValue.CompanyId === null || AdrenalinValue.CompanyId === undefined   ? "" :  AdrenalinValue.CompanyId;
        var Key = AdrenalinValue.Key === null || AdrenalinValue.Key === undefined   ? "" :  AdrenalinValue.Key;
        var FtpPath = AdrenalinValue.FtpPath === null || AdrenalinValue.FtpPath === undefined   ? "" :  AdrenalinValue.FtpPath;
        var FtpFolderBase = AdrenalinValue.FtpFolderBase === null || AdrenalinValue.FtpFolderBase === undefined   ? "" :  AdrenalinValue.FtpFolderBase;
        var FtpUser = AdrenalinValue.FtpUser === null || AdrenalinValue.FtpUser === undefined   ? "" :  AdrenalinValue.FtpUser;
        var FtpPsw = AdrenalinValue.FtpPsw === null || AdrenalinValue.FtpPsw === undefined   ? "" :  AdrenalinValue.FtpPsw;
        var EmailsAlertTo = AdrenalinValue.EmailsAlertTo === null || AdrenalinValue.EmailsAlertTo === undefined   ? "" :  AdrenalinValue.EmailsAlertTo;
        var EmailSubjectError = AdrenalinValue.EmailSubjectError === null || AdrenalinValue.EmailSubjectError === undefined   ? "" :  AdrenalinValue.EmailSubjectError;

        let stateCopy = Object.assign({}, this.state);
        stateCopy.APIUser = UserName;
        stateCopy.APIPass = Pass;
        stateCopy.EasyApiUser = EasyApiUser;
        stateCopy.EasyApiPassword = EasyApiPassword;
        stateCopy.ApiAddress = ApiAddress;
        stateCopy.ExportTimeOutMinutes = ExportTimeOutMinutes;
        stateCopy.CompanyId = CompanyId;
        stateCopy.Key = Key;
        stateCopy.FtpPath = FtpPath;
        stateCopy.FtpFolderBase = FtpFolderBase;
        stateCopy.FtpUser = FtpUser;
        stateCopy.FtpPsw = FtpPsw;
        stateCopy.EmailsAlertTo = EmailsAlertTo;
        stateCopy.EmailSubjectError = EmailSubjectError;
        this.setState(stateCopy);
    }

    handleApiUser(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.APIUser = value;
        this.setState(stateCopy);    
    }
    handleApiPass(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.APIPass = value;
        this.setState(stateCopy);    
    }
    handleEasyApiUser(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.EasyApiUser = value;
        this.setState(stateCopy);    
    }
    handleEasyApiPassword(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.EasyApiPassword = value;
        this.setState(stateCopy);    
    }
    handleApiAddress(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.ApiAddress = value;
        this.setState(stateCopy);    
    }
    handleExportTimeOutMinutes(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.ExportTimeOutMinutes = value;
        this.setState(stateCopy);    
    }
    handleCompanyId(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.CompanyId = value;
        this.setState(stateCopy);    
    }
    handleKey(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.Key = value;
        this.setState(stateCopy);    
    }
    handleFtpPath(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.FtpPath = value;
        this.setState(stateCopy);    
    }
    handleFtpFolderBase(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.FtpFolderBase = value;
        this.setState(stateCopy);    
    }
    handleFtpUser(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.FtpUser = value;
        this.setState(stateCopy);    
    }
    handleFtpPsw(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.FtpPsw = value;
        this.setState(stateCopy);    
    }
    handleEmailsAlertTo(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.EmailsAlertTo = value;
        this.setState(stateCopy);    
    }
    handleEmailSubjectError(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.EmailSubjectError = value;
        this.setState(stateCopy);    
    }

    ValidateSaveAdrenalin(){

        var UserName = this.state.APIUser;
        var Pass = this.state.APIPass;
        var ApiAddress = this.state.ApiAddress;
        var CompanyId = this.state.CompanyId;
        var Key = this.state.Key;
        var FtpPath = this.state.FtpPath;
        var FtpFolderBase = this.state.FtpFolderBase;
        var FtpUser = this.state.FtpUser;
        var FtpPsw = this.state.FtpPsw;
        var EmailsAlertTo = this.state.EmailsAlertTo;
        var EmailSubjectError = this.state.EmailSubjectError;

        if(ApiAddress === null || ApiAddress === "" || ApiAddress === undefined)
        {
            toast.error("Api Address field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(UserName === null || UserName === "" || UserName === undefined)
        {
            toast.error("Client API User field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(Pass === null || Pass === "" || Pass === undefined)
        {
            toast.error("Client API Password field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }      
        if(CompanyId === null || CompanyId === "" || CompanyId === undefined)
        {
            toast.error("CompanyId field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(Key === null || Key === "" || Key === undefined)
        {
            toast.error("Key field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(FtpPath === null || FtpPath === "" || FtpPath === undefined)
        {
            toast.error("Ftp Path field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(FtpFolderBase === null || FtpFolderBase === "" || FtpFolderBase === undefined)
        {
            toast.error("Ftp Folder Base field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(FtpUser === null || FtpUser === "" || FtpUser === undefined)
        {
            toast.error("Ftp User field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(FtpPsw === null || FtpPsw === "" || FtpPsw === undefined)
        {
            toast.error("Ftp Password field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(EmailsAlertTo === null || EmailsAlertTo === "" || EmailsAlertTo === undefined)
        {
            toast.error("Emails Alert To field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(EmailSubjectError === null || EmailSubjectError === "" || EmailSubjectError === undefined)
        {
            toast.error("Email Subject Error field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        return true;
    }
   
    SaveAdrenalin(e){
        e.preventDefault();    
        var email = sessionStorage.getItem('email');
        var that = this;
        var UserName = this.state.APIUser;
        var Pass = this.state.APIPass;
        var EasyApiUser = this.state.EasyApiUser;
        var EasyApiPassword = this.state.EasyApiPassword;
        var ApiAddress = this.state.ApiAddress;
        var ExportTimeOutMinutes = this.state.ExportTimeOutMinutes;
        var CompanyId = this.state.CompanyId;
        var Key = this.state.Key;
        var FtpPath = this.state.FtpPath;
        var FtpFolderBase = this.state.FtpFolderBase;
        var FtpUser = this.state.FtpUser;
        var FtpPsw = this.state.FtpPsw;
        var EmailsAlertTo = this.state.EmailsAlertTo;
        var EmailSubjectError = this.state.EmailSubjectError;
        var CompanyCode = this.props.CompanyCode;
        var AdrenalinList = this.props.DataAdrenalin;
        var Adrenalin = AdrenalinList.find(x=> x.ALIAS === this.state.APIName);   
        var Validate = this.ValidateSaveAdrenalin();
        if(Validate === false)
        {
            return false;
        }        
        this.setState({
            loadingAdrenalin: true
        });
        var result = APIService.SaveAdrenalinSetting(CompanyCode,email, UserName, Pass, EasyApiUser, EasyApiPassword,ApiAddress, ExportTimeOutMinutes, CompanyId,Key,
                                                    FtpPath, FtpFolderBase, FtpUser, FtpPsw, EmailsAlertTo, EmailSubjectError);

        result.then(function(data){
            if(data.data === "OK"){
                that.setState({
                    loadingAdrenalin: false
                });

                var newList = {
                    ALIAS: Adrenalin.ALIAS,
                    COMPANY_CODE: CompanyCode,
                    ID: Adrenalin.ID,
                    NAME: Adrenalin.NAME,
                    VALUE: {
                        UserName: UserName,
                        Password: Pass,
                        EasyApiUser:EasyApiUser,
                        EasyApiPassword: EasyApiPassword,
                        ApiAddress:ApiAddress,
                        ExportTimeOutMinutes: ExportTimeOutMinutes,
                        CompanyId: CompanyId,
                        Key: Key,
                        FtpUser: FtpUser,
                        FtpPath:FtpPath,
                        FtpFolderBase: FtpFolderBase,
                        FtpPsw: FtpPsw,
                        EmailsAlertTo: EmailsAlertTo,
                        EmailSubjectError: EmailSubjectError,
                        Name:Adrenalin.ALIAS
                    }
                };
                that.props.SetObject(newList);
                toast.success("Saved!", { className: {
                    opacity: 0.8
                }});            
            }else if(data.data === "NoExist"){
                that.setState({
                    loadingAdrenalin: false
                });  
                toast.error("API Setting dosen't exist!", { className: {
                    opacity: 0.8
                }});
            }else if(data.data === "Empty"){
                that.setState({
                    loadingAdrenalin: false
                });                
                toast.error("Not Exist!", { className: {
                    opacity: 0.8
                }});
            }
        }).catch((error) => {
            that.setState({
                loadingAdrenalin: false,
            });    
            if(error.response)
            {
                if(error && error.response && error.response.data.Message === "500") {               
                    toast.error("Error Data Base(Error: 500)", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NoDB") {
                   toast.error("Company Code dosen't exist!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NotReseller") {    
                   toast.error("This User does not have permission!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data.Message === "400"){ 
                   toast.error("API Error for Reseller", { className: {
                       opacity: 0.8
                   }});
                }else if(error.response.status === 401){ 
                       sessionStorage.setItem("user", '');
                       sessionStorage.setItem("token", '');
                       sessionStorage.setItem("rol", '');
                       sessionStorage.setItem("email", '');
                       sessionStorage.clear();  
                       this.setState({ isAutenticated: false },
                       ()=>{                               
                           this.forceUpdate();
                       })              
                }   
            }else{
                toast.error("Code Error", { className: {
                    opacity: 0.8
                }});
            }
        });        
    }
   
    render(){  
            
        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'}/>)
        }

        return (
            <div>
                <div className="card Logs"><ToastContainer hideProgressBar/>
                    <div className="card-body" style={{ height: "600px", 'overflowY': 'scroll'}}>
                        <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Name</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="name" id="name" type="text" value={ this.state.APIName} readOnly/>
                            </div>                          
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Easy API User</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="clientapiuser" id="clientapiuser" type="text" onChange={this.handleEasyApiUser}  value={ this.state.EasyApiUser}/>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Easy API Password</label>
                            </div>   
                            <div className="col-2">
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="clientapipass" id="clientapipass" type={this.state.APIPasswordType} onChange={this.handleEasyApiPassword }   value={ this.state.EasyApiPassword}/>
                            </div>    
                            <div className="col-2" style={{ 'paddingTop': '15px' }}>                                
                                <Badge color="default" style={{ 'cursor': 'pointer'}} className="password__show" onClick={this.showHideAPIPasswordType}>{this.state.APIPasswordType === 'input' ? 'Hide' : 'Show'}</Badge>
                            </div>                      
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Api Address(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="ApiAddress" id="ApiAddress" type="text" onChange={this.handleApiAddress}  value={ this.state.ApiAddress}/>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Export TimeOut (Min)</label>
                            </div>   
                            <div className="col-2">
                                <input type="number" style={{ 'marginTop': '10px' }} className="form-control" name="ExportTimeOutMinutes" id="ExportTimeOutMinutes"  onChange={this.handleExportTimeOutMinutes }   value={ this.state.ExportTimeOutMinutes}/>
                            </div>                         
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Client API User(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="apiuser" id="apiuser" type="text" onChange={this.handleApiUser}  value={ this.state.APIUser}/>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Client API Password(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2">
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="apipass" id="apipass" type={this.state.type} onChange={this.handleApiPass }   value={ this.state.APIPass}/>
                            </div>  
                            <div className="col-2" style={{ 'paddingTop': '15px' }}>                                
                                <Badge color="default" style={{ 'cursor': 'pointer'}} className="password__show" onClick={this.showHide}>{this.state.type === 'input' ? 'Hide' : 'Show'}</Badge>
                            </div>                          
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Company ID(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="CompanyId" id="CompanyId" type="text" onChange={this.handleCompanyId } value={ this.state.CompanyId}/>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Key(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2">
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="Key" id="Key" type="text" onChange={this.handleKey }  value={ this.state.Key}/>
                            </div>                          
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Ftp Path(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="FtpPath" id="FtpPath" type="text" onChange={this.handleFtpPath } value={ this.state.FtpPath}/>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Ftp Folder Base(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2">
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="FtpFolderBase" id="FtpFolderBase" type="text" onChange={this.handleFtpFolderBase }  value={ this.state.FtpFolderBase}/>
                            </div>                          
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Ftp User(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="FtpUser" id="FtpUser" type="text" onChange={this.handleFtpUser } value={ this.state.FtpUser}/>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Ftp Password(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2">
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="FtpPsw" id="FtpPsw" type={this.state.FTPPasswordType} onChange={this.handleFtpPsw }  value={ this.state.FtpPsw}/>
                            </div>                             
                            <div className="col-2" style={{ 'paddingTop': '15px' }}>                                
                                <Badge color="default" style={{ 'cursor': 'pointer'}} className="password__show" onClick={this.showHideFTPPasswordType}>{this.state.FTPPasswordType === 'input' ? 'Hide' : 'Show'}</Badge>
                            </div>                          
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Emails Alert To(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="EmailsAlertTo" id="EmailsAlertTo" type="text" onChange={this.handleEmailsAlertTo} value={ this.state.EmailsAlertTo}/>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Email Subject Error(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2">
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="EmailSubjectError" id="EmailSubjectError" type="text" onChange={this.handleEmailSubjectError }  value={ this.state.EmailSubjectError}/>
                            </div>                                       
                            <div className="col-2 offset-1"  size="sm" >
                                <ClipLoader
                                    className={override}
                                    sizeUnit={"px"}
                                    size={30}
                                    color={'#33B5E5'}
                                    loading={this.state.loadingAdrenalin}
                                />
                                {
                                    this.state.loadingAdrenalin
                                    ?
                                    <Button   color="info" tag="a" onClick={(e)=>this.SaveAdrenalin(e)} disabled>Save</Button>
                                    : 
                                    <Button   color="info" tag="a" onClick={(e)=>this.SaveAdrenalin(e)}>Save</Button>
                                }
                               
                            </div>                             
                       </div>
                   </div>
                </div>
            </div>            
        );
    }
}

export default Adrenalin;


// WEBPACK FOOTER //
// ./src/APIComponent/Adrenalin.jsx